import DiceIcon from './DiceIcon'

export default DiceIcon
